import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './fuentes';
import './styles/tokens.css';
import './styles/base.css';
import { App } from './App';
import { DatosProvider } from './datos/DatosContext';
import { fuenteFicticia } from './datos/ficticia';

// Fuente de datos activa. Hoy: datos ficticios en memoria. Ninguna conexión externa.
const fuente = fuenteFicticia;

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Falta el elemento #root en index.html');

createRoot(raiz).render(
  <StrictMode>
    <DatosProvider fuente={fuente}>
      <App />
    </DatosProvider>
  </StrictMode>
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.error('No se pudo registrar el service worker:', error);
    });
  });
}

